var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisionaiBrowseprompt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.293,
    height: 20,
    viewBox: "0 0 20.293 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_107270",
    "data-name": "Group 107270",
    transform: "translate(-6614 -4571)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_107269",
    "data-name": "Group 107269"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40435",
    "data-name": "Rectangle 40435",
    width: 20,
    height: 20,
    transform: "translate(6614 4571)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106160",
    "data-name": "Path 106160",
    d: "M1.162,6A1.173,1.173,0,0,0,0,7.181V21.105a.408.408,0,0,0,.408.408H11.132a4.869,4.869,0,0,1-.476-.817H.817V11.716H17.963v2.967a4.915,4.915,0,0,1,.817.74V7.181A1.173,1.173,0,0,0,17.618,6Zm0,.817H17.618a.355.355,0,0,1,.345.364V10.9H.817V7.181A.355.355,0,0,1,1.162,6.817Zm5.779.817v2.45h9.8V7.633ZM2.45,8.041a.817.817,0,1,0,.817.817A.817.817,0,0,0,2.45,8.041Zm2.45,0a.817.817,0,1,0,.817.817A.817.817,0,0,0,4.9,8.041Zm2.858.408h8.165v.817H7.757Zm7.349,6.124a4.083,4.083,0,1,0,2.581,7.241l2.029,2.029.577-.577-2.029-2.029a4.078,4.078,0,0,0-3.158-6.664Zm0,.817a3.266,3.266,0,1,1-3.266,3.266A3.26,3.26,0,0,1,15.105,15.39Z",
    transform: "translate(6614 4566)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisionaiBrowseprompt);
export default __webpack_public_path__ + "static/media/visionai_browseprompt.7855d3dcc4da946467d3f7bda13064cc.svg";
export { ForwardRef as ReactComponent };